export default "__VITE_ASSET__a031a3b1__"